import { render, staticRenderFns } from "./ListFaq.vue?vue&type=template&id=69fce0d2&"
import script from "./ListFaq.vue?vue&type=script&lang=js&"
export * from "./ListFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports